import { ICarbonFootprintDetailsData } from "./Shipment.CarbonFootprintDetails.types";
import { apiClients } from "../../settings";

export default class CarbonFootprintDetailsApi {
  static async getCarbonFootprintDetails({ queryKey }: any) {
    const [_, shipmentNumber] = queryKey;

    try {
      let res = await apiClients[1].get(`/V1/carbon/shipments/${shipmentNumber}`);

      return res.data as ICarbonFootprintDetailsData[];
    } catch (e: any) {
      console.error('Could not get Carbon Footprint Details data:', e.message);
      return undefined;
    }
  }
}